import _ from 'underscore';
import { Base } from './base';
import { IEnumValidator } from '../types';

/**
 * Enum validator which checks whether a value is contained within the enumerators.
 * @param {array} enumerators - Possible values.
 * @param {I18nModel} i18n - Provides the getString callback, used in the Base class.
 */
class Enum extends Base implements IEnumValidator {
  enumerators: unknown[];

  constructor(enumerators: unknown[], i18n: I18nModel) {
    super(i18n);
    this.enumerators = enumerators.slice();
  }

  isValidValue(value: unknown): boolean {
    return _.contains(this.enumerators, value);
  }
}

/**
 * Create an enum validator instance.
 * @param {array} enumerators - Possible values.
 * @param {I18nModel} i18n - Provides the getString callback, used in the Base class.
 * @returns {IEnumValidator} - An instance of the enum validator.
 */
export function enumeration(enumerators: unknown[], i18n: I18nModel): IEnumValidator {
  return new Enum(enumerators, i18n);
}
